const Loading = () => {
  return (
    <div className="flex items-center justify-center h-96">
      <span className="text-xl font-medium tracking-wide">Loading...</span>
    </div>
  );
};

export default Loading;
